import { create } from "zustand";

export const useApiLoadingStore = create((set) => ({
  pendingCount: 0,
  isLoading: false,
  start: () =>
    set((state) => {
      const pendingCount = state.pendingCount + 1;
      return { pendingCount, isLoading: pendingCount > 0 };
    }),
  end: () =>
    set((state) => {
      const pendingCount = Math.max(0, state.pendingCount - 1);
      return { pendingCount, isLoading: pendingCount > 0 };
    }),
}));

export function selectApiLoading(state) {
  return state.isLoading;
}
